// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "changeSet": "8140",
    "buildNumber": "17230",
    "buildJob": "Collect.vNext.UI",
    "buildAgent": "TFS",
    "buildTime": "04/09/2025 16:30:07"
};
/* tslint:enable */
